import React, { useMemo } from "react";

import { Order } from "../../../../../../../services";
import { useAppContext } from "../../../../../../../context";
import { CellContentRoot } from "..";

import cellProcessing from "./cellProcessing";

const CreateOrderTimeCellContent: React.FC<
	CreateOrderTimeCellContent.Props
> = ({ item }) => {
	const { dateFns } = useAppContext();

	const content = useMemo(
		() => cellProcessing(item.createdAt, dateFns),
		[item.createdAt, dateFns],
	);

	return (
		<CellContentRoot alignItems="center" h="100%" w="100%">
			{content}
		</CellContentRoot>
	);
};

declare namespace CreateOrderTimeCellContent {
	interface Props {
		item: Order.Model;
	}
}

export default CreateOrderTimeCellContent;
